import { Column, Columns } from '@codeparva/ui-components-library';
import React from 'react';
import { Row } from '../../../../../components/row/Row';
import { weakKey } from '../../../../../utilities/weakKey';
import { LocationTypes } from '../locationTypes';
import { useVariant } from '../../../../contactUsPage/hooks/VariantContext';

export const LocationHours = React.memo(
  ({ facilityHours }: LocationTypes.ILocationHours) => {
    const variant = useVariant();
    return (
      <Column>
        {facilityHours.map(facilityHour => {
          const [day, timings] = facilityHour.split(': ');
          return (
            <Row
              className={`is-cp-w-100 ${
                variant === 'newContactUsDarkTheme' ? 'm-0' : ''
              } pb-3`}
              key={weakKey({ key: facilityHour })}
            >
              <Columns vCentered className="is-mobile is-cp-w-100">
                {day ? (
                  <>
                    <p className="p-2 mb-2">
                      {day} : {timings}
                    </p>
                  </>
                ) : (
                  <Column size="three-fifths" className="p-2 mb-2">
                    <p>{timings}</p>
                  </Column>
                )}
              </Columns>
            </Row>
          );
        })}
      </Column>
    );
  }
);
